import { getSuppliersApi } from "services/poService"
import { GET_SUPPLIERS_FAILURE, GET_SUPPLIERS_REQUEST, GET_SUPPLIERS_RESET, GET_SUPPLIERS_SUCCESS } from "./action-type"

export const getSuppliers = (payload) => {
    return (dispatch) => {
        dispatch(getSuppliersRequest())
        getSuppliersApi(payload)
        .then(response => {
            if(response.status === 200){
                dispatch(getSuppliersSuccess(response));
            } else {
                dispatch(getSuppliersFailure(response));
            }
        })
        .catch(error => {
            dispatch(getSuppliersFailure(error));
        })
    }
}

export const getSuppliersRequest = () => {
    return {
        type: GET_SUPPLIERS_REQUEST
    }
}

export const getSuppliersSuccess = (response) => {
    return {
        type: GET_SUPPLIERS_SUCCESS,
        getSuppliersResponse: response
    }
}

export const getSuppliersFailure = (error) => {
    return {
        type: GET_SUPPLIERS_FAILURE,
        getSuppliersResponse: error
    }
}

export const getSuppliersReset = () => {
    return {
        type: GET_SUPPLIERS_RESET
    }
}